import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { transactionTypes } from '@/returns/constants'

const TransactionTypeSelector = ({ onChange, value = [] }) => {
  const { t } = useTranslation()
  const options = [
    { label: t('Devolución'), value: transactionTypes.refund },
    { label: t('Cambio'), value: transactionTypes.exchange },
  ]

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <div>
      <ComboBox
        value={value || []}
        label={t('Tipo de transacción')}
        fullWidth
        multiple
        handleChange={handleChange}
        menuItems={options}
      />
    </div>
  )
}

export default TransactionTypeSelector
